// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_jr-1";
export var rowFirst = "_jr-3";
export var rowLast = "_jr-5";
export var rowMiddle = "_jr-4";
export var ticketListScroll = "_jr-2";
export var ticketStack = "_jr-0";